// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__5ktSl","left":"styles_left__36n6h"};